define([
	"dojo/_base/declare",
	"csi",
	"csi/action/EditController",
	"./ProductType"
], function(declare,csi,EditController,ProductType) {

return declare(EditController,
	{
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default value for request level
			view.addFixedValue("SampleStorage", this.getNode().SampleStorage);

			// there is no view controller for Material - see if we should hide Colors / Sizes fields
			var product = this.m_cache.getPathNode(this.getNode(), "Child:__Parent__/Child:__Parent__/Child:__Parent__");
			var colorsField = view.getField("ProductColor");
			var sizesField  = view.getField("ProductSize");

			if (colorsField && !ProductType.hasColor(product))
				colorsField.bHidden = true;
			if (sizesField && !ProductType.hasSize(product))
				sizesField.bHidden = true;

			this.inherited(arguments);
		}
	}
);

});